import type { NavItemDef } from "@/app/gameNavigation";
import { getMessages } from "@/i18n/runtime";

export interface ScreenCollection {
  readonly root: HTMLDivElement;
  readonly screens: ReadonlyMap<string, HTMLDivElement>;
}

export function createScreenCollection(
  items: readonly NavItemDef[],
  screenIdsWithCustomContent: ReadonlySet<string>,
): ScreenCollection {
  const messages = getMessages();
  const root = document.createElement("div");
  root.className = "hover-idle-root";

  const screens = new Map<string, HTMLDivElement>();
  for (const item of items) {
    const screen = document.createElement("div");
    screen.className = "hover-idle-screen";
    if (item.id !== "hovTarget") {
      screen.hidden = true;
    }
    if (!screenIdsWithCustomContent.has(item.id)) {
      const placeholder = document.createElement("div");
      placeholder.className = "hover-idle-draft-placeholder";
      placeholder.textContent = item.draft
        ? messages.navigation.draftPlaceholder(item.screenLabel)
        : item.screenLabel;
      screen.append(placeholder);
    }
    screens.set(item.id, screen);
    root.append(screen);
  }

  return { root, screens };
}
